import { KdsActionId, toActionIds } from '../Types/KdsAuthorization'

// The allowed-actions claim name is an unfrozen cross-team decision -- isolated here so it can
// change in one place. Never verifies the token; decode-only, for local preflight.
const ALLOWED_ACTIONS_CLAIM = 'kds_actions'

// Claim values other than kds_actions are never read, so this doesn't need a UTF-8-safe decode --
// a plain atob+JSON.parse round-trip is enough to extract the ASCII action-id strings.
function decodeJwtPayload(token: string): Record<string, unknown> | undefined {
  try {
    const payload = token.split('.')[1]
    if (!payload) return undefined

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    return JSON.parse(atob(padded))
  } catch {
    return undefined
  }
}

/**
 * Best-effort only: the backend is authoritative for what an action can do.
 *
 * `undefined` is reserved for a missing/non-array/unparseable claim, which the coordinator treats
 * as "let the backend decide". A present-but-empty (or all-unrecognized) claim returns `[]` so the
 * coordinator's preflight rejects the action locally instead of issuing a request that can only 403.
 */
export function extractAllowedActions(token: string): KdsActionId[] | undefined {
  const raw = decodeJwtPayload(token)?.[ALLOWED_ACTIONS_CLAIM]
  if (!Array.isArray(raw)) return undefined

  return toActionIds(raw)
}
